import {
  CopilotDocumentIngestSourceType,
  CopilotDocumentIngestStatus,
  CopilotDocumentStorageSourceType,
} from 'models/copilot/copilotDocumentIngest';
import { CopilotGenericContentDTO } from './copilotGenericDTO';

export class CopilotDocumentCategorySuggestionDTO {
  listId?: number;

  listName?: string;

  confidence?: number;

  rationale?: string;
}

export class CopilotDocumentIngestDTO {
  sessionId?: number;

  contextKey?: string;

  sourceType: CopilotDocumentIngestSourceType;

  storageSourceType: CopilotDocumentStorageSourceType;

  uploadedBlobName?: string;

  libraryLinkId?: number;

  libraryListId?: number;

  title?: string;

  fileName?: string;

  mimeType?: string;

  markdown?: string;

  suggestedListId?: number;

  saveToLibraryListId?: number;

  categorySuggestion?: CopilotDocumentCategorySuggestionDTO;

  constructor() {
    this.sourceType = CopilotDocumentIngestSourceType.Upload;
    this.storageSourceType = CopilotDocumentStorageSourceType.StorageAccount;
  }
}

export class CopilotDocumentIngestPayloadDTO {
  sourceType: CopilotDocumentIngestSourceType;

  storageSourceType: CopilotDocumentStorageSourceType;

  tempBlobName?: string;

  tempBlobExpires?: string;

  originalLibraryLinkId?: number;

  originalLibraryListId?: number;

  suggestedListId?: number;

  sourceTitle?: string;

  sourceFileName?: string;

  mimeType?: string;

  constructor() {
    this.sourceType = CopilotDocumentIngestSourceType.Upload;
    this.storageSourceType = CopilotDocumentStorageSourceType.StorageAccount;
  }
}

export class CopilotDocumentIngestResultDTO {
  status: CopilotDocumentIngestStatus;

  message?: string;

  content?: CopilotGenericContentDTO;

  payload?: CopilotDocumentIngestPayloadDTO;

  pendingIngest?: CopilotDocumentIngestDTO;

  categorySuggestion?: CopilotDocumentCategorySuggestionDTO;

  constructor() {
    this.status = CopilotDocumentIngestStatus.Failed;
  }
}
